var exports = {
  "kL": "ScopeSheet.module__container___Umdlb3",
  "XG": "ScopeSheet.module__scroller___Umdlb3",
  "iy": "ScopeSheet.module__optionsContainer___Umdlb3",
  "uK": "ScopeSheet.module__option___Umdlb3",
  "h4": "ScopeSheet.module__optionSelected___Umdlb3",
  "ts": "ScopeSheet.module__optionLeft___Umdlb3",
  "H9": "ScopeSheet.module__optionIcon___Umdlb3",
  "AJ": "ScopeSheet.module__optionIconSelected___Umdlb3",
  "re": "ScopeSheet.module__optionText___Umdlb3",
  "ed": "ScopeSheet.module__optionLabel___Umdlb3",
  "tD": "ScopeSheet.module__optionLabelSelected___Umdlb3",
  "q3": "ScopeSheet.module__optionDescription___Umdlb3",
  "oE": "ScopeSheet.module__checkIcon___Umdlb3",
};

module.exports = exports;
